import RichText from '@/components/ui/RichText'
import { useLanguage } from '@/context/LanguageContext'
import { PackageInfo } from '@/services/cms-api/service-menu/types'
import { resolveImageUrl } from '@/utils/constants'
import { isNil } from '@/utils/validations'
import Image from 'next/image'
import { FunctionComponent } from 'react'
import DynamicTable from './dynamic-table'

interface Prop {
  data?: PackageInfo
}
const PackageInfoRenderer: FunctionComponent<Prop> = ({ data }) => {
  const { locale } = useLanguage()
  if (data === undefined) {
    return <></>
  }
  return (
    <div className='w-full flex flex-col items-center'>
      {(!isNil(data.headerEn) && !isNil(data.headerMn)) && (
        <h1 className='font-bold md:text-4xl text-xl pb-10 text-textHigh'>{locale === 'en' ? data.headerEn : data.headerMn}</h1>
      )}
      {
       (!isNil(data.imageEn) && !isNil(data.imageMn)) && (
         <Image
           draggable={false}
           alt='img'
           width={1000}
           height={1000}
           className='w-full h-fit'
           src={resolveImageUrl((locale === 'en' ? data.imageEn : data.imageMn))}
         />
       )
      }
      {
       (!isNil(data.descriptionEn) && !isNil(data.descriptionMn)) && (
         <span>{locale === 'en' ? data.descriptionEn : data.descriptionMn}</span>
       )
      }
      <RichText content={locale === 'en' ? data.bodyEn : data.bodyMn} />
      <div className='flex flex-col rounded-xl w-full'>
        {data.table && <DynamicTable data={data.table} />}
      </div>
    </div>
  )
}
export default PackageInfoRenderer
